import { useEffect, useContext, useState } from "react";
import Utils from "../../Utils";
import axios from "axios";

import PhNotifications from "../../components/photographer/PhNotifications";
import PhCertification from "../../components/photographer/PhCertification";

const PhDashboard = (props) => {

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
    });
  };
  /* Classes for specific status */
  const statusClasses = {
    "In-Process": "status-pill inline-block bg-yellow-100 text-yellow-800",
    "Pending": "status-pill inline-block bg-pink-50 text-pink-700",
    "Completed": "status-pill inline-block bg-gray-200 text-gray-700",
  };
  /* Labels for status */
  const getStatusLabel = (status) => {
    const code = Number(status);

    if (code === 0 || code === 1) return 'Pending';
    if (code >= 2 && code <= 6) return 'In-Process';
    if (code === 7 || code === 8) return 'Completed';

    return 'Unknown';
  };
  const hotelDetailsFromAttrs = (attrs) => {
    return attrs.split('#');
  }

  /* Getting status for number */
  const [status, setStatus] = useState([]);
  useEffect(() => {
    axios
        .get(Utils.apiUrl(`psstatus`), Utils.apiHeaders())
        .then((res) => {
          if(res.data.success) {
            setStatus(res.data.statuses);
          }
        })
        .catch((err) => {
          //callback(false, err.message);
        });
  }, []);

  const [activePhotoshoot, setActivePhotoshoot] = useState([]);
  useEffect(() => {
    axios
        .get(Utils.apiUrl(`photoshoot/listing?sortBy=created_at&sortDir=desc&limit=1`), Utils.apiHeaders())
        .then((res) => {
            console.log(res.data);
          if(res.data.success) {
            setActivePhotoshoot(res.data.data);
            //setHotelDetailsAttr(hotelDetailsFromAttrs(res.data.data[0].hotel_attrs));
          }
        })
        .catch((err) => {
          //callback(false, err.message);
        });
  }, []);


  return (
    <>
      <div class="container mx-auto px-8 py-8">
        <h1 class="text-3xl font-bold text-gray-800 mb-8">Photographer Dashboard</h1>

        {/* <!-- Notifications Section --> */}
        <PhNotifications />
        {/* <!-- Certification Status --> */}
        <PhCertification />

        {/* <!-- Photoshoot Request Creation Section --> */}
        {activePhotoshoot.length > 0 && activePhotoshoot.map((item) => (
            <>
            <div class="dashboard-section">
                <div class="section-title">
                    <i class="fas fa-camera-retro"></i>
                    Photoshoot Request Details
                </div>
                
                <div class="bg-gradient-to-r from-gray-50 to-gray-100 p-6 rounded-lg border border-gray-200 mb-2">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
                        <div>
                            <p class="text-sm text-gray-600 font-semibold uppercase tracking-wide mb-2">Hotel Name</p>
                            <p class="text-lg font-bold text-gray-800">{hotelDetailsFromAttrs(item.hotel_attrs)[0]}</p>
                        </div>
                        <div>
                            <p class="text-sm text-gray-600 font-semibold uppercase tracking-wide mb-2">Create Photoshoot Request</p>
                            <p class="text-lg font-bold text-gray-800">
                                <a href={`photographer-photoshoot-request/${item.id}`} class="btn px-4 py-2 rounded text-white font-semibold text-sm flex items-center space-x-2 hover:opacity-90">
                                    <i class="fa-regular fa-camera"></i>
                                    <span>Photoshoot Request</span>
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            </>
        ))}

        {/* <!-- Photoshoot Request Section --> */}
        {activePhotoshoot.length > 0 && activePhotoshoot.map((item) => (
            <>
            <div class="dashboard-section">
                <div class="section-title">
                    <i class="fas fa-camera-retro"></i>
                    Recce Request Details
                </div>
                <div class="bg-gradient-to-r from-gray-50 to-gray-100 p-6 rounded-lg border border-gray-200">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
                        <div>
                            <p class="text-sm text-gray-600 font-semibold uppercase tracking-wide mb-2">Hotel Name</p>
                            <p class="text-lg font-bold text-gray-800">{hotelDetailsFromAttrs(item.hotel_attrs)[0]}</p>
                        </div>
                        <div>
                            <p class="text-sm text-gray-600 font-semibold uppercase tracking-wide mb-2">Date Range</p>
                            <p class="text-lg font-bold text-gray-800">
                                <i class="fas fa-calendar-alt text-gray-600"></i>
                                {formatDate(item.date_from)} to {formatDate(item.date_to)}
                            </p>
                        </div>
                    </div>
                    <div class="mt-6 pt-6 border-t border-gray-300 flex items-center justify-between">
                        <p class="text-sm text-gray-600 font-semibold uppercase tracking-wide">Status: {status[item.status]}</p>
                        {/* <span class="status-badge status-in-progress">
                            <i class="fas fa-hourglass-half"></i> In-Progress
                        </span> */}
                        <div className={statusClasses[getStatusLabel(item.status)]}><i class="fa-solid fa-circle"></i></div>
                    </div>

                    <div class="mt-4">
                        <a href={`photographer-photoshoot-details/${item.id}`} class="btn px-4 py-2 rounded text-white font-semibold text-sm flex items-center space-x-2 hover:opacity-90">
                            <i class="fas fa-file-alt"></i>
                            <span>Recce Deck</span>
                        </a>
                    </div>
                </div>
            </div>
            </>
        ))}

    </div>
    </>
  );
};

export default PhDashboard;
